/** Prefers-reduced-motion: avoid heavy animations for accessibility and low-power devices. */
export const shouldReduceMotion =
  typeof window !== "undefined" &&
  !!window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
